var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDockout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0158 3.30754L6.51036 0.0391061C6.29083 -0.0369372 6.04979 -0.000350192 5.8604 0.133802C5.67173 0.268671 5.55981 0.48604 5.55981 0.717757V13.6308C5.55981 13.8525 5.6624 14.0612 5.83673 14.1968C5.9637 14.2965 6.11938 14.3482 6.2772 14.3482C6.33603 14.3482 6.39557 14.341 6.45368 14.3259L15.9591 11.9083C16.2769 11.8273 16.5 11.541 16.5 11.2132V3.98619C16.5 3.67986 16.3056 3.40725 16.0158 3.30754ZM15.0652 10.6558L6.99459 12.7082V1.72282L15.0652 4.4984V10.6558Z",
    fill: "#172B4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7979 12.0626C4.7979 11.6658 4.47723 11.3452 4.08051 11.3452H1.43478V3.85275H4.08051C4.47723 3.85275 4.7979 3.53208 4.7979 3.13536C4.7979 2.73864 4.47723 2.41797 4.08051 2.41797H0.71739C0.320673 2.41797 0 2.73864 0 3.13536V12.0626C0 12.4593 0.320673 12.78 0.71739 12.78H4.08051C4.47651 12.78 4.7979 12.4593 4.7979 12.0626Z",
    fill: "#172B4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50535 8.37019C10.9401 8.37019 10.9401 6.21802 9.50535 6.21802C8.07057 6.21802 8.07057 8.37019 9.50535 8.37019Z",
    fill: "#172B4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDockout);
export default __webpack_public_path__ + "static/media/dockout.e350f620bffa9e51eb75224b900b789e.svg";
export { ForwardRef as ReactComponent };